import moment from 'moment-timezone';
import { OlyEngineApi } from '@sportheroes/oly-engine-api';
import { getDeviceId, getDeviceName, getCredentials, storeAccessToken, removeCredentials, } from './utils';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const timezone = moment().tz(moment.tz.guess());
const { USERS_API_URL = '', CLIENT_ID = '' } = process.env;
const { refreshToken = '', accessToken = '' } = (getCredentials === null || getCredentials === void 0 ? void 0 : getCredentials()) || {};
export const baseHeaders = {
    'x-device-id': getDeviceId === null || getDeviceId === void 0 ? void 0 : getDeviceId(),
    'x-device-name': getDeviceName === null || getDeviceName === void 0 ? void 0 : getDeviceName(),
    timezone,
};
export const baseTokenConfig = {
    tokenApiUrl: `${USERS_API_URL}/`,
    refreshToken,
    accessToken,
    storeAccessToken,
    onLogout: removeCredentials,
    clientId: CLIENT_ID,
};
export const olyEngineApi = new OlyEngineApi({
    headers: baseHeaders,
    tokenConfig: baseTokenConfig,
});
